import { useEffect, useState } from "react";
import { ContainerScreenGeneral, MuniSpinner2, Table } from "../../components";
import { useActasStore } from "../../store/actasStore";
import { useActaDetalleStore } from "../../store/actaDetalleStore";
import { tableData } from "./tableData";
import RangoFecha from "../../components/RangoFecha";
import { filtrarActas, orderActas } from "./handler";
import { filterRangoFecha } from "../../utils/filterRangoFechas";
import { useActas } from "../../hooks/useActas";
import ModalsOpcionesActas from "../../views/modals";
import useNotificadores from "../../api/notificadores";
import FilterBar from "./components/FilterBar";
import { useNotificadoresStore } from "../../store/notificadoresStore";
import HeaderNotificador from "./components/HeaderNotificador";
import Table2 from "../../components/Table2";
import NotificadoresBar from "./components/NotificadoresBar/NotificadoresBar";
import { reporteNotificadoresHandler } from "../../handlers/notificadores.handler";
import ModalFiltroFechas from "../../views/modals/ModalFiltroFechas";
import { format } from 'date-fns'
import NotificadoresBar2 from "./components/NotificadoresBar/NotificadoresBar2";

const ReportesNotificadores = () => {

    //TODO ESTADOS GLOBALES
    const { actas, actasFilter, setActasFilter, cleanActas, codigosZonales } = useActasStore();
    // const { notificadores, notificadorSelect, filterReporteNotificadores, reporteNotificador, fechasReporte } = useNotificadoresStore();
    const { notificadores, notificadorSelect, filterReporteNotificadores, reporteNotificador, fechasReporte, filterEstado, submitFilter, setFilterEstado } = useNotificadoresStore();
    const { cleanStore, coleccionActasDetalle, setAllActaDetalle } = useActaDetalleStore();


    //^ ESTADOS LOCALES
    const [order, setOrder] = useState("des");
    const [orderField, setOrderField] = useState("numero_acta");
    const [filtersField, setFiltersField] = useState({
        fecha_hora: "",
    })

    const fechaHoy = new Date();
    const fechaUnMesAntes = new Date(fechaHoy);
    fechaUnMesAntes.setMonth(fechaUnMesAntes.getMonth() - 1);
    const fechaHaceUnMes = fechaUnMesAntes;

    const [filtros, setFiltros] = useState({
        fecha_desde: fechaHaceUnMes,
        fecha_hasta: fechaHoy,
    });
    // const [filtros, setFiltros] = useState({
    //     fecha_desde: fechaHaceUnMes,
    //     fecha_hasta: fechaHoy,
    // });

    //~ HOOKS
    const { getActas, getActaDetalle } = useActas()
    const { getNotificadores } = useNotificadores()

    const loadKeys = [
        "asignar_notificador",
        "acta_detalle",
        "desasignar_notificador",
        "marcar_impresa",
        "actas",
        "notificadores"
    ];

    useEffect(() => {
        // getActas('reportes_notificadores')
        // getNotificadores()
        setFilterEstado('todas')
        return () => {
            cleanStore();
            cleanActas();
        }
    }, [])

    /* useEffect(() => {

        if (notificadorSelect && fechasReporte) {
            reporteNotificadoresHandler({
                user_id: notificadorSelect?.usuarioID,
                fecha_desde: format(fechasReporte?.fecha_desde, 'yyyy-MM-dd'),
                fecha_hasta: format(fechasReporte?.fecha_hasta, 'yyyy-MM-dd'),
            })
            // console.log('entre')
        }

    }, [notificadorSelect, fechasReporte]) */

    useEffect(() => {

        if (notificadorSelect && fechasReporte && filterEstado && submitFilter) {
            reporteNotificadoresHandler({
                user_id: notificadorSelect?.usuarioID,
                fecha_desde: format(fechasReporte?.fecha_desde, 'yyyy-MM-dd'),
                fecha_hasta: format(fechasReporte?.fecha_hasta, 'yyyy-MM-dd'),
                estado_id: filterEstado
            })
            // console.log('entre')
        }

    }, [submitFilter])

    // console.log(reporteNotificador)

    //* VEEEER
    // useEffect(() => {

    //     if (filterReporteNotificadores) {
    //         reporteNotificadoresHandler(filterReporteNotificadores);
    //     }

    // }, [filterReporteNotificadores])


    // useEffect(() => {
    //     if (actas) {
    //         const actasFiltradas = filtrarActas(null, actas, filtersField, order, orderField, codigosZonales);
    //         setActasFilter(actasFiltradas)
    //     }
    // }, [filtersField, order, orderField, filtros])

    // console.log(filtersField)
    return (
        <ContainerScreenGeneral titulo={'Reporte de notificadores'} linkBack={'/'} size={'lg'}>
            <div className="position-relative">

                {/* <NotificadoresBar setFiltersField={setFiltersField} setFiltros={setFiltros} filtros={filtros} /> */}
                <NotificadoresBar2 setFiltersField={setFiltersField} setFiltros={setFiltros} filtros={filtros} />
               
            </div>
            <ModalsOpcionesActas />


        </ContainerScreenGeneral>
    );
}
export default ReportesNotificadores;